import { Controller } from "@hotwired/stimulus"

// Lightweight inline list search controller for dropdown submenus and modals.
// Filters child items by matching input text against their text content,
// with optional category filtering via a select dropdown.
//
// Usage:
//   <div data-controller="list-search">
//     <input data-list-search-target="input" data-action="input->list-search#filter">
//     <select data-list-search-target="categorySelect" data-action="change->list-search#filter">
//     <div data-list-search-target="item" data-category="real_estate">Item text</div>
//     <div data-list-search-target="empty" style="display: none;">No results</div>
//   </div>
export default class extends Controller {
  static targets = ["input", "item", "empty", "categorySelect"]

  filter() {
    const query = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : ""
    const category = this.hasCategorySelectTarget ? this.categorySelectTarget.value : ""
    let visibleCount = 0

    this.itemTargets.forEach(item => {
      const matchesText = !query || item.textContent.toLowerCase().includes(query)
      const itemCategory = item.dataset.category || ""
      const matchesCategory = !category || itemCategory === category

      if (matchesText && matchesCategory) {
        item.removeAttribute("hidden")
        item.style.display = ""
        visibleCount++
      } else {
        item.setAttribute("hidden", "")
        item.style.display = "none"
      }
    })

    if (this.hasEmptyTarget) {
      const hasFilter = query.length > 0 || category.length > 0
      this.emptyTarget.style.display = visibleCount === 0 && hasFilter ? "" : "none"
    }
  }
}
